module.exports = __webpack_public_path__ + "static/TwitterBackground-9d594686984fdf47914a2305950bb925.jpg";